// Module
var code = "<p>Create a simple quote then send it to your customer by email and text message. You’ll get notified when it’s opened and we’ll back everything up to the cloud, so even if you lose your device, all your paperwork is safe.<br/><br/>For more complex quotes or to add photos, use Projects.</p>\n";
// Exports
module.exports = code;